module.exports = __webpack_public_path__ + "img/right-4.32e50ddc.jpg";